module.exports = __webpack_public_path__ + "static/media/011_GF Step 5 MPA @2x.cb6c46f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/farmers/011_GF Step 5 MPA @2x.png
// module id = 423
// module chunks = 0